/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Split_EventInputs */



/**
* | output |
* | --- |
* | "Split Event" |
*
* @param {Shortcut_Keys_Name_Split_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_split_event = /** @type {((inputs?: Shortcut_Keys_Name_Split_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Split_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diviser l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Split Event")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento diviso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разделенное событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento dividido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分裂事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("分割イベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विभाजन घटना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento dividido")
	return /** @type {LocalizedString} */ ("Split Event")
});